import { render, staticRenderFns } from "./AnimateValue.vue?vue&type=template&id=670cbe24&"
import script from "./AnimateValue.vue?vue&type=script&lang=ts&"
export * from "./AnimateValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports